module.exports = __webpack_public_path__ + "static/media/form.f5ca727a.svg";